import { styled } from "@/stitches/config"

export const SFormInputGroup = styled("div", {})

export const SFormInputGroupItems = styled("div", {
  display: "flex",
  alignItems: "center",
  position: "relative",
  gap: "$12",
})

export const SFormInputGroupItem = styled("div", {
  flex: 1,
  position: "relative",
})
